import { Bento } from "../components/Bento";
import { t } from "@/i18n-js/instance";
import TotalEmailsSent from "./assets/total-emails-sent.png";
import { SanitizeHTMLString } from "@/react/components/shared/uikit/SanitizeContent";
import { abbreviateNumber } from "@/react/helpers/number";
import SubscribersGrowth from "./assets/subscribers-growth.png";
import MostEngagingEmail from "./assets/most-engaging-email.png";

const i18nRoot = "eoy_recap_2025.sections.reach";

import type { EmailHighlightsMetrics } from "../../types";

interface ReachProps {
  data?: EmailHighlightsMetrics;
}

export const Reach = ({ data }: ReachProps) => {
  if (!data) return null;

  return (
    <Bento
      id="email-highlights"
      accentColor="#EAA620"
      title={t([i18nRoot, "title"])}
    >
      <Bento.Item id="total-emails-sent" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col h-full overflow-hidden">
          <div className="p-8">
            <p className="text-4xl md:text-6xl font-bold mb-2">
              {abbreviateNumber(data.total_emails_sent)}
            </p>
            <p className="text-base font-medium leading-none tracking-[-0.25px] text-white mb-4">
              {t([i18nRoot, "bento_items.emails_sent"])}
            </p>
          </div>
          <img
            src={TotalEmailsSent}
            alt={t([i18nRoot, "bento_items.total_events_hosted"])}
            loading="lazy"
          />
        </div>
      </Bento.Item>
      <Bento.Item
        id="average-open-or-click-rates"
        baseColSpan={1}
        baseRowSpan={3}
      >
        <div className="flex flex-col h-full p-8">
          <p className="text-4xl font-bold mb-2 text-center leading-8">
            <SanitizeHTMLString
              content={t([i18nRoot, "bento_items.average_open_or_click_rates"])}
            />
          </p>

          <div className="flex-1 min-h-0 flex items-center justify-center">
            <p className="text-[6.375rem] font-bold leading-[100%] uppercase text-[#EAA620] mt-4">
              {data.click_rates}
            </p>
          </div>
        </div>
      </Bento.Item>
      <Bento.Item id="most-engaging-email" baseColSpan={1} baseRowSpan={3}>
        <div className="flex flex-col h-full overflow-hidden">
          <div className="px-8 pt-8">
            <p className="text-4xl font-bold mb-2 text-center leading-8">
              <SanitizeHTMLString
                content={t([i18nRoot, "bento_items.most_engaging_email"])}
              />
            </p>
          </div>
          <img
            src={MostEngagingEmail}
            alt={t([i18nRoot, "bento_items.most_engaging_email"])}
            loading="lazy"
            className="mb-0 mt-auto"
          />
        </div>
      </Bento.Item>
      <Bento.Item id="subscriber-growth" baseColSpan={3} baseRowSpan={2}>
        <div className="flex flex-row justify-between size-full overflow-hidden">
          <div className="px-8 pt-8 min-w-fit">
            <p className="text-4xl md:text-6xl font-bold">
              {data.subscribers_growth}
            </p>
            <p className="text-base font-medium leading-none tracking-[-0.25px] text-white mb-4">
              {t([i18nRoot, "bento_items.subscriber_growth"])}
            </p>
          </div>
          <img
            src={SubscribersGrowth}
            alt={t([i18nRoot, "bento_items.subscriber_growth"])}
            loading="lazy"
            className="opacity-90 size-full object-cover absolute bottom-0 right-0 rounded-2xl md:relative"
          />
        </div>
      </Bento.Item>
    </Bento>
  );
};
